<template>
    <el-table :data="tableData" :span-method="spanMethod" header-align="center" border>
        <el-table-column :label="$t('sensory.calibration.user')" prop="userName"  min-width="300"></el-table-column>
        <el-table-column :label="$t('nav.plant')" prop="plantName" min-width="300" ></el-table-column>
        <el-table-column :label="$t('sensory.calibration.singleBatchScore')" prop="singleBatchScore" min-width="300" ><template slot-scope="scope">{{scope.row.singleBatchScore}}%</template></el-table-column>
        <el-table-column :label="$t('sensory.calibration.avgScore')" prop="avgScore" min-width="300" ><template slot-scope="scope">{{scope.row.avgScore}}%</template></el-table-column>
        <el-table-column :label="$t('sensory.calibration.passStatus')" prop="passStatus" min-width="300" ></el-table-column>
    </el-table>
</template>

<script>
    import commonFun from "@/utils/commonFun";

    export default {
        name: "personnelCalibration",
        props: {
            personnelCalibration: {
                type: Object,
                default: []
            },
        },
        data() {
            return {
                tableData: []
            }
        },
        created() {
            this.initData();
        },
        watch: {
            personnelCalibration(newValue, oldValue) {
                this.initData();
            }
        },
        methods: {
            spanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex != 2) {
                    if (row.scoreIndex == 0) {
                        return [row.rowSpan,1];
                    } else {
                        return [0, 0];
                    }
                }
            },
            initData() {
                let tableData = [];
                if (commonFun.isEmpty(this.personnelCalibration)) {
                    return;
                }
                this.personnelCalibration.forEach(detail=>{
                    detail.scoreList.forEach((score,index)=>{
                        let row = {};
                        row.scoreIndex = index;
                        row.userName = detail.userName;
                        row.plantName = detail.plantName;
                        row.singleBatchScore = score;
                        row.avgScore = detail.average;
                        row.rowSpan = detail.scoreList.length;
                        row.passStatus = detail.pass;
                        tableData.push(row);
                    })
                });
                this.tableData = tableData;
            }
        },

    }
</script>

<style scoped>

</style>
